import React, { useEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { getCachedMediaUrl, cacheMediaUrl } from './offline/offlineMediaCache';

export default function VideoPlayer({ url, title, exerciseId }) {
  const [mediaUrl, setMediaUrl] = useState(url);
  const [isCached, setIsCached] = useState(false);
  const [cacheLoading, setCacheLoading] = useState(false);

  const isGif = url?.toLowerCase().split('?')[0].endsWith('.gif');

  useEffect(() => {
    let alive = true;
    let objectUrl = null;

    const loadCached = async () => {
      try {
        if (!url || !('caches' in window)) {
          setMediaUrl(url);
          return;
        }

        const cachedObjectUrl = await getCachedMediaUrl(url);

        if (cachedObjectUrl && alive) {
          objectUrl = cachedObjectUrl;
          setMediaUrl(cachedObjectUrl);
          setIsCached(true);
        } else if (alive) {
          setMediaUrl(url);
          setIsCached(false);
        }
      } catch {
        if (alive) {
          setMediaUrl(url);
          setIsCached(false);
        }
      }
    };

    loadCached();

    return () => {
      alive = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url]);

  const downloadForOffline = async () => {
    try {
      if (!url) return;

      setCacheLoading(true);

      await cacheMediaUrl(url);

      const cachedObjectUrl = await getCachedMediaUrl(url);

      if (cachedObjectUrl) {
        setMediaUrl(cachedObjectUrl);
        setIsCached(true);
      }
    } catch {
      alert('ذخیره ویدیو برای حالت آفلاین با خطا مواجه شد.');
    } finally {
      setCacheLoading(false);
    }
  };

  const handleReport = async (type) => {
    try {
      const res = await fetch(`https://api.mogym.ir/api/video/report`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
        body: JSON.stringify({
          exerciseId,
          type,
        }),
      });

      if (res.ok) {
        alert('گزارش شما ثبت شد. ممنون از همکاری‌تان!');
      } else {
        alert('ثبت گزارش با خطا مواجه شد.');
      }
    } catch {
      alert('ارتباط با سرور برقرار نشد.');
    }
  };

  if (!url) return null;

  return (
    <div className="my-3">
      {isGif ? (
        <img
          src={mediaUrl || url}
          alt={title}
          className="w-full h-auto rounded-xl"
        />
      ) : (
        <ReactPlayer
          url={mediaUrl || url}
          controls
          width="100%"
          height="200px"
          style={{ borderRadius: '12px', overflow: 'hidden' }}
        />
      )}

      <div className="mt-2 flex flex-wrap items-center gap-2">
        <button
          onClick={() => handleReport('Broken')}
          className="px-3 py-1 text-xs bg-red-600 text-white rounded-xl"
        >
          گزارش خرابی ویدیو
        </button>

        <button
          onClick={() => handleReport('Incorrect')}
          className="px-3 py-1 text-xs bg-yellow-500 text-white rounded-xl"
        >
          گزارش ویدیوی اشتباه
        </button>

        {!isCached && (
          <button
            onClick={downloadForOffline}
            disabled={cacheLoading}
            className="px-3 py-1 text-xs bg-green-600 text-white rounded-xl disabled:opacity-60"
          >
            {cacheLoading ? 'در حال ذخیره...' : 'ذخیره برای آفلاین'}
          </button>
        )}

        {isCached && (
          <span className="px-3 py-1 text-xs rounded-xl bg-green-500/10 text-green-600 dark:text-green-300">
            ذخیره‌شده برای آفلاین
          </span>
        )}
      </div>
    </div>
  );
}